// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-MdmUploader-UploadInfo-UploadInfo-module__uploadInfo--NXQQ2 {
  font-size: 12px;
  color: #0000008c;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
/*# sourceMappingURL=UploadInfo.module.css.map */`, "",{"version":3,"sources":["webpack://./UploadInfo.module.less","webpack://./src/components/MdmUploader/UploadInfo/UploadInfo.module.less"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;ACCF;AACA,gDAAgD","sourcesContent":[".uploadInfo {\n  font-size: 12px;\n  color: #0000008c;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n",".uploadInfo {\n  font-size: 12px;\n  color: #0000008c;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n/*# sourceMappingURL=UploadInfo.module.css.map */"],"sourceRoot":""}]);
// Exports
export var uploadInfo = `src-components-MdmUploader-UploadInfo-UploadInfo-module__uploadInfo--NXQQ2`;
export default ___CSS_LOADER_EXPORT___;
